import { all, select, put, takeEvery } from 'redux-saga/effects';
import { path } from 'ramda';
import { toSuccess, toError } from 'react-async-client';

import { getStatus } from 'helpers/filterHelpers';
import { project as projectRoute, projectMass as projectMassRoute } from 'constants/routes';
import * as actions from 'constants/actionTypes';
import { history } from 'store/browserHistory';

import {
    getUser,
    getRequestList,
    getApprovalProjectList,
    getApprovalPersonList,
    getProjectList,
    getWorksheetList,
    getNotdoneList,
    getProjectMassList,
    getWorksheetMassList
} from 'actions/asyncActions';

const getApprovalTableStatus = () => ({
    status: getStatus(),
});

const createTableSaga = (asyncAction, UPDATE_ACTIONS, getPayload = () => {}, getParams = () => {}) => {
    function* fetchTable() {
        const tablePayload = yield select(getPayload);
        const tableParams = yield select(getParams);

        const action = {
            ...asyncAction(tablePayload),
            params: tableParams
        };

        yield put(action);
    }

    return function* updateTable() {
        yield all([
            takeEvery(UPDATE_ACTIONS, fetchTable)
        ]);
    };
};

export const request = createTableSaga(getRequestList, [
    actions.SET_REQUEST_LIST_SORT,
    actions.SET_REQUEST_LIST_PAGINATION,
    toSuccess(actions.CANCEL_REQUEST),
    toError(actions.CANCEL_REQUEST),
], getApprovalTableStatus);

export const approvalPerson = createTableSaga(getApprovalPersonList, [
    actions.SET_APPROVAL_PERSON_LIST_SORT,
    actions.SET_APPROVAL_PERSON_LIST_PAGINATION,
    toSuccess(actions.APPROVE_PERSON),
    toSuccess(actions.REJECT_PERSON),
    toError(actions.APPROVE_PERSON),
    toError(actions.REJECT_PERSON),
], getApprovalTableStatus);

export const approvalProject = createTableSaga(getApprovalProjectList, [
    actions.SET_APPROVAL_PROJECT_LIST_SORT,
    actions.SET_APPROVAL_PROJECT_LIST_PAGINATION,
    toSuccess(actions.APPROVE_PROJECT),
    toSuccess(actions.REJECT_PROJECT),
    toError(actions.APPROVE_PROJECT),
    toError(actions.REJECT_PROJECT),
], getApprovalTableStatus);

const getWorksheetListPayload = (state) => {
    const params = history.location.pathname.split('/');
    const table = getWorksheetList.selectData(state);

    return {
        id: path(['project', 'id'], table) || path([2], params),
    };
};

export const worksheet = createTableSaga(getWorksheetList, [
    actions.SET_WORKSHEET_LIST_FILTERS,
    actions.SET_WORKSHEET_LIST_PAGINATION,
    actions.SET_WORKSHEET_LIST_SORT,
    toSuccess(actions.POST_WORKSHEET_LIST_SETTINGS)
], getWorksheetListPayload);

const getProjectListPayload = (state) => {
    const user = getUser.selectData(state);
    const match = projectRoute.match(history.location.pathname);

    return {
        id: path(['id'], match) || path(['id'], user),
    };
};

const getProjectMassListPayload = (state) => {
    const user = getUser.selectData(state);
    const match = projectMassRoute.match(history.location.pathname);

    return {
        id: path(['id'], match) || path(['id'], user),
    };
};

const getWorksheetMassListParams = (state) => {
    const params = history.location.pathname.split('/');
    const table = getWorksheetList.selectData(state);

    return {
        id: path(['project', 'id'], table) || path([2], params),
        stage: path([4], params)
    };
};

export const project = createTableSaga(getProjectList, [
    actions.SET_PROJECT_LIST_FILTERS,
    actions.SET_PROJECT_LIST_PAGINATION,
    actions.SET_PROJECT_LIST_SORT,
    toSuccess(actions.POST_PROJECT_LIST_SETTINGS)
], getProjectListPayload);

export const notdone = createTableSaga(getNotdoneList, [
    actions.SET_NOTDONE_LIST_SORT,
    actions.SET_NOTDONE_LIST_PAGINATION,
]);

export const projectMass = createTableSaga(getProjectMassList, [
    actions.SET_PROJECT_MASS_LIST_FILTERS,
    actions.SET_PROJECT_MASS_LIST_PAGINATION,
    actions.SET_PROJECT_MASS_LIST_SORT,
    toSuccess(actions.POST_PROJECT_MASS_LIST_SETTINGS)
], getProjectMassListPayload);

export const worksheetMass = createTableSaga(getWorksheetMassList, [
    actions.SET_WORKSHEET_MASS_LIST_FILTERS,
    actions.SET_WORKSHEET_MASS_LIST_SORT,
    toSuccess(actions.POST_WORKSHEET_MASS_LIST_SETTINGS)
], undefined, getWorksheetMassListParams);
